// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"4fb5e004","54":"3ee09e52","64":"1ad3c7b2","423":"1169f4a9","484":"69afa1a5","964":"528c5c20"}[chunkId] + ".css";
};